import config from './config.json'
export default config[process.env.REACT_APP_ENV || 'development']
